





















































































































































































import Vue from 'vue';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Component } from 'vue-property-decorator';
import { EstadoAuditoria } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { EventosService } from '@/services/eventosService';
import { EstadoInterface } from '@/interfaces/Estado';
import { UsuariosInterface } from '@/interfaces/Usuarios';
import moment from 'moment';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  AgGridEvent,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
} from 'ag-grid-community';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import store from '@/store';
import config from '@/config/index';
import { LoadingService } from '@/services/loadingService';
const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
  },
})
export default class Auditoria extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.Auditoria;
  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionExportar,
  ];

  controller: string = 'Auditoria';
  localeText: any = config.agGridTextos;
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  gridOptions: GridOptions;
  serverSide: any;
  agGridUtil: AgGridUtil;
  estadoGrillaVm: EstadoGrillaVm;
  dformat: any = '';

  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  search: string = '';
  usuarioId: number = store.state.userId;
  $snotify: any;
  readonly controllerUsuario: string = 'usuario';

  //FILTROS AUDITORIA
  eventosServices: EventosService = new EventosService();
  eventos: EstadoInterface[] = this.eventosServices.getEventos();
  usuarios: UsuariosInterface[] = [];
  filtroGrillaEvento: any = null;
  filtroGrillaUsuario: any = null;
  filtroGrillaFechaD = moment(new Date())
    .add(-7, 'days')
    .toISOString()
    .substr(0, 10);
  filtroGrillaFechaH: any = new Date().toISOString().substr(0, 10);
  menuDatePickerFechaD: boolean = false;
  menuDatePickerFechaH: boolean = false;
  keyDatePickers: number = 0;
  limpiarGrilla: boolean = true;
  btnDisabled: boolean = false;
  //---

  paramsExportar: any; //Parametros para Exportar
  showCantidadRegistros: boolean = false;

  loadingService = new LoadingService();

  constructor() {
    super();

    this.estadoGrillaVm = {
      id: 0,
      grilla: '',
      usuarioId: this.usuarioId,
      funcionalidades: this.funcionalidad,
    };

    this.columnDefs = [
      {
        headerName: 'Código',
        field: 'id',
        //suppressMenu: true,
        enablePivot: false,
        sortable: false,
        width: 200,
        minWidth: 80,
        resizable: true,
        hide: true,
        lockPinned: true,
      },
      {
        headerName: 'Entidad',
        field: 'entidad',
        width: 200,
        minWidth: 80,
        filter: false,
        suppressMovable: true,
        resizable: true,
        sortable: false,
        enablePivot: false,
        pinned: 'left',
        lockVisible: true,
        rowDrag: false,
      },
      {
        headerName: 'Usuario',
        field: 'usuario',
        sortable: false,
        resizable: true,
        lockPinned: true,
        width: 200,
        minWidth: 80,
      },
      {
        headerName: 'Evento',
        field: 'eventoTxt',
        sortable: false,
        resizable: true,
        width: 200,
        minWidth: 80,
        lockPinned: true,
        /*cellRenderer: (r: any) => {
          return EstadoAuditoria[r.data.evento];
        },*/
      },
      {
        headerName: 'Detalle',
        field: 'detalle',
        sortable: false,
        resizable: true,
        lockPinned: true,
        width: 200,
        minWidth: 80,
      },
      {
        headerName: 'Fecha',
        field: 'fechaTxt',
        lockPinned: true,
        /*cellRenderer: (r: any) => {
          return this.formatDateTime(r.value);
        },*/
        sortable: false,
        resizable: true,
        width: 200,
        minWidth: 80,
      },
      /*{
        headerName: "Acciones",
        width: 120,
        minWidth: 120,
        filter: false,
        suppressMovable: true,
        resizable: false,
        sortable: false,
        enablePivot: false,
        pinned: "right",
        lockVisible: true,
        rowDrag: false
      }*/
    ];

    this.gridOptions = {
      rowSelection: 'multiple',
      pagination: true,
      domLayout: 'autoHeight',
      paginationPageSize: 50,
      cacheBlockSize: 10000, //Solución Paginación
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      localeText: this.localeText,
      onGridReady: this.onGridReady,
      columnDefs: this.columnDefs,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass,
      onDragStopped: this.onDragStoppedEvent,
      onColumnVisible: this.onColumnVisibleEvent,
      onColumnPinned: this.onColumnPinnedEvent,
      blockLoadDebounceMillis: 350,
      suppressCsvExport: true,
      suppressExcelExport: true,
    };
  }

  async created() {
    this.limpiarGrilla = true;
    this.keyDatePickers += 1;
    await this.getUsuarios();
  }

  onFilterTextBoxChanged() {
    let flagEvento: boolean = this.validaNulo(this.filtroGrillaEvento);
    let flagFechaD: boolean = this.validaNulo(this.filtroGrillaFechaD);
    let flagFechaH: boolean = this.validaNulo(this.filtroGrillaFechaH);
    let flagUsuario: boolean = this.validaNulo(this.filtroGrillaUsuario);

    /*//Limitar la Búsqueda a una Semana
    let fechaD: any = moment(this.filtroGrillaFechaD);
    let fechaH: any = moment(this.filtroGrillaFechaH);
    let numDias: number = fechaH.diff(fechaD, 'days');
    if (numDias > 7) {
      this.$snotify.warning('El rango de fechas no puede ser mayor a X días');
      return;
    }
    //---*/

    if (
      this.search.length >= 2 ||
      flagEvento ||
      flagFechaD ||
      flagFechaH ||
      flagUsuario
    ) {
      this.gridApi.onFilterChanged();
    } else if (
      this.search.length === 0 &&
      !flagEvento &&
      !flagFechaD &&
      !flagFechaH &&
      !flagUsuario
    ) {
      this.gridApi.setServerSideDatasource(this.serverSide);
    }
  }

  validaNulo(item: any): boolean {
    if (item !== null && item !== undefined) return true;
    else return false;
  }

  clearFilters() {
    this.btnDisabled = true;
    this.search = '';
    this.filtroGrillaEvento = null;
    this.filtroGrillaUsuario = null;
    this.filtroGrillaFechaD = moment(new Date())
      .add(-7, 'days')
      .toISOString()
      .substr(0, 10);
    this.filtroGrillaFechaH = new Date().toISOString().substr(0, 10);
    this.menuDatePickerFechaD = false;
    this.menuDatePickerFechaH = false;
    this.limpiarGrilla = true;
    this.gridApi.showNoRowsOverlay();
    //this.gridApi.sizeColumnsToFit();
    this.gridApi.setServerSideDatasource(this.serverSide);
    setTimeout(() => {
      this.btnDisabled = false;
    }, 3000);
    //this.onFilterTextBoxChanged();
  }

  onColumnVisibleEvent(event: ColumnVisibleEvent) {
    this.agGridUtil.guardarEstadoGrilla();
  }

  onColumnPinnedEvent(event: ColumnPinnedEvent) {
    this.agGridUtil.guardarEstadoGrilla();
  }

  onDragStoppedEvent(event: DragStoppedEvent) {
    this.agGridUtil.guardarEstadoGrilla();
  }

  isExternalFilterPresent(): boolean {
    return true;
  }

  doesExternalFilterPass(node: RowNode): boolean {
    return true;
  }

  //Cambia Propiedad de Filtro en Grilla
  changeSortingProperty(val: boolean) {
    const columns = this.columnDefs.filter((column: ColDef) => {
      return column.headerName !== '' && column.headerName !== 'Acciones';
    });
    columns.forEach((item: any) => {
      item.sortable = val;
    });
  }
  //---

  onGridReady(params: GridReadyEvent) {
    this.loadingService.showLoading();
    const self = this;
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    this.agGridUtil = new AgGridUtil(
      this.gridApi,
      this.columnApi,
      this.estadoGrillaVm
    );

    this.serverSide = {
      getRows(params: any): void {
        params.request.search = self.search;
        params.request.clienteId = config.getClienteSesion();
        params.request.estadoEntidad = self.filtroGrillaEvento;
        params.request.fechaDesde = self.filtroGrillaFechaD;
        params.request.fechaHasta = self.filtroGrillaFechaH;
        params.request.usuarioId = self.filtroGrillaUsuario;
        params.request.paginationSize = self.gridOptions.cacheBlockSize; //Solución Paginación
        self.paramsExportar = params; //Parametros al Exportar

        self.axios.http
          .post(`${self.controller}/grid`, params.request)
          .then(log => {
            if (log.data.data.length === 0 || self.limpiarGrilla) {
              self.changeSortingProperty(false); //Cambia Propiedad de Filtro en Grilla
              self.gridApi.setColumnDefs(self.columnDefs); //Cambia Propiedad de Filtro en Grilla
              self.gridApi.showNoRowsOverlay();
              params.successCallback([{}], 0);
              self.limpiarGrilla = false;
            } else {
              if (log.data.lastRow > 5000) {
                self.changeSortingProperty(false); //Cambia Propiedad de Filtro en Grilla
                self.gridApi.setColumnDefs(self.columnDefs); //Cambia Propiedad de Filtro en Grilla
                self.gridApi.showNoRowsOverlay();
                params.successCallback([{}], 0);
                self.limpiarGrilla = false;
                self.showCantidadRegistros = true; //Mostrar modal de cantidad de registros
              } else {
                self.changeSortingProperty(true); //Cambia Propiedad de Filtro en Grilla
                self.gridApi.setColumnDefs(self.columnDefs); //Cambia Propiedad de Filtro en Grilla
                self.gridApi.hideOverlay();
                params.successCallback(log.data.data, log.data.lastRow);
              }
            }
            //self.gridApi.sizeColumnsToFit();
            self.loadingService.hideLoading();
          })
          .catch(err => {
            params.failCallback();
            self.loadingService.hideLoading();
          });
      },
    };
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  beforeDestroy() {
    this.agGridUtil.guardarEstadoGrilla().finally(() => {
      this.gridApi.destroy();
    });
  }

  async getUsuarios() {
    const loadingKey = 'getUsuarios';
    const clientSession: any = config.getClienteSesion();
    try {
      this.loadingService.showLoading(undefined, loadingKey);
      const response = await this.axios.http.get(
        `Usuario/${this.usuarioId}/${clientSession}/getUsuariosAuditoria`
      );
      this.usuarios = response.data;
    } catch (error) {
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.$snotify.error('Ocurrió un error al obtener lista de Usuarios');
        }
      } else {
        this.$snotify.error('Ocurrió un error al obtener lista de Usuarios');
      }
    } finally {
      this.loadingService.hideLoading(loadingKey);
    }
  }

  get computedDateFormattedFechaD() {
    return this.formatDate(this.filtroGrillaFechaD);
  }

  get computedDateFormattedFechaH() {
    return this.formatDate(this.filtroGrillaFechaH);
  }

  get minDate() {
    return this.filtroGrillaFechaD;
  }

  get maxDate() {
    return this.filtroGrillaFechaH;
  }

  formatDateTime(fecha: Date): string {
    if (!fecha) return null;
    return moment(fecha).format('DD/MM/YYYY HH:mm:ss');
  }

  formatDate(fecha: String): string {
    if (!fecha) return null;
    const [year, month, day] = fecha.toString().split('-');
    return `${day}/${month}/${year}`;
  }

  exportar() {
    let totalFilas = this.gridApi.paginationGetRowCount();
    if (totalFilas > 0) {
      this.loadingService.showLoading();
      this.paramsExportar.request.startRow = 0;
      this.paramsExportar.request.endRow = totalFilas;
      this.paramsExportar.request.paginationSize = totalFilas;

      this.axios.http
        .post(`${this.controller}/grid`, this.paramsExportar.request)
        .then(respServer => {
          config.crearArchivoCsv(
            'Auditoria.csv',
            respServer.data.data,
            this.columnDefs
          );
          this.loadingService.hideLoading();
          this.$snotify.success(this.$t('mensajes.mensajesExito.exportar'));
        })
        .catch(err => {
          this.loadingService.hideLoading();
          if (!err.response) {
            this.$snotify.error('Ocurrió un error al exportar.');
          }
        });
    } else {
      this.loadingService.hideLoading();
      this.$snotify.warning('No existen datos para exportar.');
    }
  }

  confirmCallbackCantidadRegistros(val: boolean) {
    this.showCantidadRegistros = false;
  }
}
